import { Typography } from '@euler/app/components/typography';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { View } from 'react-native';

export const GatewayDeviceScreen = wrapNavigatorScreen(() => {
  return (
    <View>
      <Typography.Label>Not supported on web</Typography.Label>
    </View>
  );
});
